var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExclamation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "#D8D8D8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Delete Users"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_24_242)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -790,
    y: -377,
    width: 1638,
    height: 1024,
    rx: 30,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 427323292",
    filter: "url(#filter0_f_24_242)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "BG",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M848 -377V647H-790V-377H848Z",
    fill: "#EBF7E2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle bg",
    filter: "url(#filter1_d_24_242)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M788 -347C804.568 -347 818 -333.569 818 -317V587C818 603.569 804.568 617 788 617H-380C-396.569 617 -410 603.569 -410 587V4C-410 -16.9868 -427.013 -34 -448 -34H-702.5C-723.211 -34 -740 -50.7893 -740 -71.5C-740 -92.2107 -723.211 -109 -702.5 -109H-448C-427.013 -109 -410 -126.013 -410 -147V-317C-410 -333.569 -396.569 -347 -380 -347H788Z",
    fill: "#FAFFF6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Objects"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 2061",
    opacity: 0.1,
    x: 9,
    y: -4,
    width: 120,
    height: 26,
    rx: 8,
    fill: "#64B431"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Active",
    d: "M53.0074 10.7788H48.6511L47.8486 13H46.4729L50.0841 3.06931H51.5887L55.1855 13H53.8099L53.0074 10.7788ZM52.6348 9.71843L50.8292 4.67427L49.0236 9.71843H52.6348ZM56.4154 9.05925C56.4154 8.24722 56.5779 7.54027 56.9027 6.93841C57.2275 6.327 57.6765 5.85411 58.2497 5.51974C58.8324 5.18537 59.4964 5.01819 60.2416 5.01819C61.2064 5.01819 61.9994 5.25225 62.6203 5.72036C63.2509 6.18847 63.6664 6.8381 63.867 7.66924H62.4627C62.329 7.19157 62.0662 6.81422 61.6746 6.53717C61.2924 6.26012 60.8148 6.1216 60.2416 6.1216C59.4964 6.1216 58.8945 6.37954 58.436 6.89542C57.9774 7.40175 57.7481 8.12302 57.7481 9.05925C57.7481 10.005 57.9774 10.7359 58.436 11.2517C58.8945 11.7676 59.4964 12.0256 60.2416 12.0256C60.8148 12.0256 61.2924 11.8918 61.6746 11.6243C62.0567 11.3568 62.3194 10.9747 62.4627 10.4779H63.867C63.6569 11.2804 63.2365 11.9252 62.606 12.4125C61.9755 12.8901 61.1873 13.129 60.2416 13.129C59.4964 13.129 58.8324 12.9618 58.2497 12.6274C57.6765 12.2931 57.2275 11.8202 56.9027 11.2088C56.5779 10.5973 56.4154 9.88084 56.4154 9.05925ZM67.341 6.22191V10.8505C67.341 11.2326 67.4222 11.5049 67.5846 11.6673C67.747 11.8202 68.0288 11.8966 68.43 11.8966H69.3901V13H68.2151C67.489 13 66.9445 12.8328 66.5815 12.4985C66.2184 12.1641 66.0369 11.6148 66.0369 10.8505V6.22191H65.0195V5.14716H66.0369V3.16962H67.341V5.14716H69.3901V6.22191H67.341ZM71.7869 3.87179C71.5386 3.87179 71.3284 3.78581 71.1564 3.61385C70.9845 3.44189 70.8985 3.23172 70.8985 2.98333C70.8985 2.73494 70.9845 2.52477 71.1564 2.35281C71.3284 2.18085 71.5386 2.09487 71.7869 2.09487C72.0258 2.09487 72.2264 2.18085 72.3888 2.35281C72.5608 2.52477 72.6467 2.73494 72.6467 2.98333C72.6467 3.23172 72.5608 3.44189 72.3888 3.61385C72.2264 3.78581 72.0258 3.87179 71.7869 3.87179ZM72.4175 5.14716V13H71.1134V5.14716H72.4175ZM77.7066 11.7963L80.1427 5.14716H81.5327L78.4517 13H76.9328L73.8518 5.14716H75.2561L77.7066 11.7963ZM90.1242 8.77265C90.1242 9.02104 90.1099 9.28375 90.0812 9.5608H83.8047C83.8524 10.3346 84.1151 10.9413 84.5928 11.3807C85.08 11.8106 85.6676 12.0256 86.3554 12.0256C86.9191 12.0256 87.3872 11.8966 87.7597 11.6386C88.1419 11.3712 88.4094 11.0177 88.5622 10.5782H89.9666C89.7564 11.3329 89.336 11.9491 88.7055 12.4268C88.075 12.8949 87.2916 13.129 86.3554 13.129C85.6102 13.129 84.9415 12.9618 84.3492 12.6274C83.7665 12.2931 83.3079 11.8202 82.9735 11.2088C82.6392 10.5878 82.472 9.87128 82.472 9.05925C82.472 8.24722 82.6344 7.53549 82.9592 6.92408C83.284 6.31267 83.7378 5.84455 84.3205 5.51974C84.9129 5.18537 85.5911 5.01819 86.3554 5.01819C87.1006 5.01819 87.7597 5.1806 88.3329 5.50541C88.9061 5.83022 89.3456 6.27923 89.6513 6.85243C89.9666 7.41608 90.1242 8.05615 90.1242 8.77265ZM88.7772 8.50038C88.7772 8.00361 88.6673 7.57848 88.4476 7.22501C88.2279 6.86198 87.9269 6.58971 87.5448 6.4082C87.1722 6.21713 86.7566 6.1216 86.2981 6.1216C85.6389 6.1216 85.0753 6.33177 84.6071 6.75212C84.1486 7.17247 83.8859 7.75522 83.819 8.50038H88.7772Z",
    fill: "#64B431"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 2049",
    opacity: 0.3,
    x: -790,
    y: -377,
    width: 1638,
    height: 1024,
    fill: "#1D1E2C"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Delete Popup"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 2050",
    filter: "url(#filter2_d_24_242)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -219,
    y: -40,
    width: 495,
    height: 350,
    rx: 18,
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M28 0C35.4261 0 42.548 2.94999 47.799 8.20101C53.05 13.452 56 20.5739 56 28C56 35.4261 53.05 42.548 47.799 47.799C42.548 53.05 35.4261 56 28 56C20.5739 56 13.452 53.05 8.20101 47.799C2.94999 42.548 0 35.4261 0 28C0 20.5739 2.94999 13.452 8.20101 8.20101C13.452 2.94999 20.5739 0 28 0ZM28 52C34.3652 52 40.4697 49.4714 44.9706 44.9706C49.4714 40.4697 52 34.3652 52 28C52 21.6348 49.4714 15.5303 44.9706 11.0294C40.4697 6.52856 34.3652 4 28 4C21.6348 4 15.5303 6.52856 11.0294 11.0294C6.52856 15.5303 4 21.6348 4 28C4 34.3652 6.52856 40.4697 11.0294 44.9706C15.5303 49.4714 21.6348 52 28 52ZM31 41C31 41.7956 30.6839 42.5587 30.1213 43.1213C29.5587 43.6839 28.7956 44 28 44C27.2044 44 26.4413 43.6839 25.8787 43.1213C25.3161 42.5587 25 41.7956 25 41C25 40.2044 25.3161 39.4413 25.8787 38.8787C26.4413 38.3161 27.2044 38 28 38C28.7956 38 29.5587 38.3161 30.1213 38.8787C30.6839 39.4413 31 40.2044 31 41ZM28 12C28.5304 12 29.0391 12.2107 29.4142 12.5858C29.7893 12.9609 30 13.4696 30 14V32C30 32.5304 29.7893 33.0391 29.4142 33.4142C29.0391 33.7893 28.5304 34 28 34C27.4696 34 26.9609 33.7893 26.5858 33.4142C26.2107 33.0391 26 32.5304 26 32V14C26 13.4696 26.2107 12.9609 26.5858 12.5858C26.9609 12.2107 27.4696 12 28 12Z",
    fill: "#FF3D00"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_24_242",
    x: -802,
    y: -389,
    width: 1662,
    height: 1048,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    result: "effect1_foregroundBlur_24_242"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_24_242",
    x: -755,
    y: -367,
    width: 1608,
    height: 1014,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 10,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_24_242"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_24_242",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_24_242",
    x: -246,
    y: -57,
    width: 545,
    height: 400,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2,
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_24_242"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_24_242",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_24_242"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -790,
    y: -377,
    width: 1638,
    height: 1024,
    rx: 30,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamation);
export default __webpack_public_path__ + "static/media/exclamation.8a90cdde1fe492733e3a7180219dc704.svg";
export { ForwardRef as ReactComponent };